import apiClient from './axios';

export const _GuideoApi = {
    url: import.meta.env.VITE_GUIDEO_API_URL,
    ver: import.meta.env.VITE_GUIDEO_API_VERSION
};

// API 請求集中管理
export const api = {

    // 新增 agent 相關 API
    getknowledge: {
        getKnowledge: (id) => apiClient.get(`/api/agent/getknowledge`, {
            params: {
                id: id
            }
        }),
        getConfig: () => apiClient.get(`/api/agent/config`),
    },
    // 添加 chat API
    chat: {
        sendMessage: (guid, agencyCode, question, travelId) => apiClient.post(`/api/agent/chat`, {
            guid: guid,
            agencyCode: agencyCode,
            question: question,
            travelId: travelId
        }),
        sendMessageByVisitor: (messages) => apiClient.post(`/api/agent/chatByVisitor`, {
            messages: messages
        }),
    },
    // Log相關API
    log: {
        logAIQA: _GuideoApi.url ? async (aiSecret, question, questionTime, answerContent, answerTime) => await apiClient.post(`${_GuideoApi.url}/log/AIQAVisitLog`, {
            version: _GuideoApi.ver,
            aiSecret: aiSecret,
            content: {
                questionContent: question,
                questionTime: questionTime,
                answerContent: answerContent,
                answerTime: answerTime
            }
        }) : async () => undefined ,
    }
};

// 錯誤處理輔助函數
export const handleApiError = (error) => {
    if (error.response) {
        // 服務器回應的錯誤
        console.error('Response error:', error.response.data);
        return error.response.data;
    } else if (error.request) {
        // 請求發送失敗
        console.error('Request error:', error.request);
        return { error: '網絡請求失敗' };
    } else {
        // 其他錯誤
        console.error('Error:', error.message);
        return { error: '發生未知錯誤' };
    }
}; 